import { useState, useEffect, useCallback } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import InboundHeader from "../../components/header/InboundHeader";
import AdminMessageBanner from "../../components/inbound/AdminMessageBanner";
import AdminMessagePopup  from "../../components/inbound/AdminMessagePopup";
import { getActiveMessages } from "../../services/adminService";

const DISMISSED_KEY = "msg_dismissed";

function getDismissed() {
  try { return JSON.parse(sessionStorage.getItem(DISMISSED_KEY) || "[]"); } catch { return []; }
}
function addDismissed(id) {
  const list = getDismissed();
  if (!list.includes(id)) sessionStorage.setItem(DISMISSED_KEY, JSON.stringify([...list, id]));
}

const InboundLayout = () => {
  const [bannerMessages, setBannerMessages] = useState([]);
  const [popupQueue,     setPopupQueue]     = useState([]);

  const loadMessages = useCallback(async () => {
    try {
      const data = await getActiveMessages();
      const dismissed = getDismissed();
      const fresh = (Array.isArray(data) ? data : []).filter(m => !dismissed.includes(m.id));
      setBannerMessages(fresh.filter(m => m.type === "HEADER"));
      setPopupQueue(fresh.filter(m => m.type === "POPUP"));
    } catch {}
  }, []);

  useEffect(() => { loadMessages(); }, [loadMessages]);

  const dismissBanner = (id) => {
    addDismissed(id);
    setBannerMessages(prev => prev.filter(m => m.id !== id));
  };

  const dismissPopup = () => {
    const current = popupQueue[0];
    if (current) addDismissed(current.id);
    setPopupQueue(prev => prev.slice(1));
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "background.default",
      }}
    >
      <InboundHeader />

      {bannerMessages.map(msg => (
        <AdminMessageBanner key={msg.id} message={msg} onDismiss={() => dismissBanner(msg.id)} />
      ))}

      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          p: 0,
        }}
      >
        <Outlet />
      </Box>

      <AdminMessagePopup message={popupQueue[0] ?? null} onClose={dismissPopup} />
    </Box>
  );
};

export default InboundLayout;